import React from 'react';
import FinalForm from '@framework/ui/Organisms/FinalForm';
import FinsightModal from '@/creditflowresearch/ui/common/components/FinsightModal';
import { useRequestServiceModalContext } from '@/creditflowresearch/application/RequestServiceModalContext';
import { IRequestServiceData } from './IRequestServiceData';
import RequestServiceFields from './RequestServiceFields';
import validator from './validator';

const RequestServiceModal = () => {
  const {
    isOpen,
    titleModal,
    isFetching,
    closeModal,
    onSubmit,
  } = useRequestServiceModalContext();

  return (
    <FinsightModal
      hideOnOverlayClicked
      isSuccessOverlay={ false }
      modalTitle={ titleModal }
      isFetching={ isFetching }
      isVisible={ isOpen }
      dataTest="requestServiceModal"
      onCloseClicked={ closeModal }
    >
      <FinalForm<IRequestServiceData, Partial<IRequestServiceData>>
        dataTest="requestServiceForm"
        render={ () => <RequestServiceFields /> }
        validate={ validator }
        onSubmit={ onSubmit }
      />
    </FinsightModal>
  );
};

export default RequestServiceModal;
